<template>
  <div>
    <el-row :gutter="15" class="bg-white pb-5">
      <el-col :span="24">
        <el-row :gutter="15">
          <el-col :span="12" class="mb-5 ">
            <h3 class="text-l font-semibold">CAPACITACIONES</h3>
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="24">
        <div class="flex flex-col space-y-4">
          <div class="flex flex-row justify-between">
            <el-col :span="5">
              <el-input
                placeholder="Buscar capacitación"
                v-model="searchTraining"
                size="small"
                suffix-icon="el-icon-search"
              />
            </el-col>
            <div>
              <el-button @click="showModalNewTraining()" size="small"
                >Nueva Capacitación</el-button
              >
              <el-button @click="showModalRangeReport()" size="small"
                >Reporte</el-button
              >
            </div>
          </div>
          <el-col :span="24">
            <el-table :data="trainings" style="width: 100%" size="small">
              <el-table-column type="expand">
                <template slot-scope="props">
                  <div class="flex flex-row col-span-3 gap-11">
                    <div>
                      <b>Clasificación:</b> {{ props.row.clasification }}
                    </div>
                    <div>
                      <b>Costo INSAFORP:</b> ${{ props.row.costInsaforp }}
                    </div>
                    <div><b>Costo LACTOLAC:</b> ${{ props.row.costLac }}</div>
                    <div><b>Costo Total:</b> ${{ props.row.totalCost }}</div>
                    <div><b>Duración:</b> {{ props.row.duration }}Hrs</div>
                    <div>
                      <b>Fecha Inicio:</b>
                      {{ props.row.startDate | formatDate }}
                    </div>
                    <div>
                      <b>Fecha Finalización:</b>
                      {{ props.row.endDate | formatDate }}
                    </div>
                    <div><b>Comentarios:</b><br />{{ props.row.comments }}</div>
                  </div>
                  <hr />
                  <div class="float-right mt-3">
                    <el-select
                      v-model="actualEmployeeSelected"
                      size="mini"
                      filterable
                      placeholder="Lista de Empleados"
                    >
                      <el-option
                        v-for="item in employeesFiltered(props.row.employees)"
                        :key="item.id"
                        :label="fullname(item)"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                    <el-button
                      type="primary"
                      size="mini"
                      @click="addEmployeeToTraning(props.row)"
                      :loading="loading"
                      >Agregar empleado
                    </el-button>
                  </div>
                  <template v-if="props.row.employees.length > 0">
                    <h2 class="text-xl underline">
                      Empleados que recibieron la capacitación
                    </h2>
                    <el-table
                      :data="props.row.employees"
                      style="width: 100%"
                      stripe
                      size="mini"
                    >
                      <el-table-column prop="code" label="Empleado" width="100">
                      </el-table-column>
                      <el-table-column label="Nombre">
                        <template slot-scope="sc">
                          {{
                            sc.row.name1 +
                              " " +
                              sc.row.name2 +
                              " " +
                              sc.row.name3 +
                              " " +
                              sc.row.lastname1 +
                              " " +
                              sc.row.lastname2 +
                              " " +
                              sc.row.lastname3
                          }}
                        </template>
                      </el-table-column>
                      <el-table-column
                        prop="department.name"
                        label="Puesto"
                        min-width="80"
                      >
                      </el-table-column>
                      <el-table-column align="right">
                        <template slot-scope="emp">
                          <el-button
                            size="mini"
                            type="danger"
                            :loading="loading"
                            @click="
                              deleteEmployeeToTraning(props.row, emp.row.id)
                            "
                            icon="el-icon-delete"
                            circle
                          ></el-button>
                        </template>
                      </el-table-column>
                    </el-table>
                  </template>
                </template>
              </el-table-column>

              <el-table-column
                prop="title"
                label="Capacitación"
                min-width="200"
              >
              </el-table-column>

              <el-table-column label="Duración" min-width="60">
                <template slot-scope="scope">
                  {{ scope.row.duration + " Hrs" }}
                </template>
              </el-table-column>
              <el-table-column label="Fecha del curso">
                <template slot-scope="scope">
                  {{ scope.row.startDate | formatDate }}
                </template>
              </el-table-column>

              <el-table-column label="Costo($)">
                <template slot-scope="scope">
                  {{ "$" + scope.row.totalCost }}
                </template>
              </el-table-column>
              <el-table-column
                prop="trainer"
                label="Capacitador"
              ></el-table-column>
              <el-table-column fixed="right" label="Operaciones" width="120">
                <template slot-scope="scope">
                  <el-button
                    @click="editTraining(scope.row)"
                    type="text"
                    size="small"
                    >Editar</el-button
                  >

                  <el-button
                    @click="printTraining(scope.row)"
                    type="text"
                    size="small"
                    ><i class="el-icon-fa-print"></i
                  ></el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
        </div>
      </el-col>
    </el-row>

    <el-dialog
      :visible.sync="showAddTraining"
      width="900px"
      :close-on-click-modal="false"
      top="5%"
      :fullscreen="true"
    >
      <h2 class="text-2xl mb-4 font-bold">Ingresar nueva Capacitación</h2>
      <el-form
        class="px-8"
        ref="form"
        :model="newTraining"
        label-position="top"
        label-width="120px"
      >
        <div class="flex  flex-wrap">
          <div class="w-full mr-5">
            <el-form-item label="Titulo">
              <el-input v-model="newTraining.title"></el-input>
            </el-form-item>
          </div>
          <div class="w-full mr-5">
            <el-form-item label="Clasificación">
              <el-input v-model="newTraining.clasification"></el-input>
            </el-form-item>
          </div>
          <div class="w-full mr-5">
            <el-form-item label="Capacitador">
              <el-input v-model="newTraining.trainer"></el-input>
            </el-form-item>
          </div>
          <div class="w-full flex justify-between ">
            <div class="w-64 mr-5">
              <el-date-picker
                v-model="rangeDate"
                format="dd/MM/yyyy"
                type="daterange"
                range-separator="A"
                start-placeholder="Fecha de inicio"
                end-placeholder="Fecha de fin"
              >
              </el-date-picker>
            </div>
            <div class="w-64 mr-5">
              <el-form-item label="Duración">
                <el-input v-model="newTraining.duration"></el-input>
              </el-form-item>
            </div>
          </div>

          <div class="w-64 mr-5">
            <el-form-item label="Costo Lactolac">
              <el-input v-model="newTraining.costLac"></el-input>
            </el-form-item>
          </div>
          <div class="w-64 mr-5">
            <el-form-item label="Costo Insaforp">
              <el-input v-model="newTraining.costInsaforp"></el-input>
            </el-form-item>
          </div>
          <div class="w-64 mr-5">
            <el-form-item label="Costo Total">
              <el-input :value="totalCostComputed"></el-input>
            </el-form-item>
          </div>
          <div class="w-full mr-5">
            <el-form-item label="Comentarios">
              <el-input
                type="textarea"
                :rows="2"
                v-model="newTraining.comments"
              ></el-input>
            </el-form-item>
          </div>
        </div>
        <el-button type="primary" @click="createTraining()" :loading="loading"
          >Crear Capacitación</el-button
        >
      </el-form>
    </el-dialog>

    <el-dialog
      title="Reporte por rango"
      :visible.sync="showRangeReport"
      width="30%"
      center
    >
      <span>Seleccione el rago de fecha que desea mostrar en el reporte:</span>
      <div class="flex flex-col mr-5">
        <el-date-picker
          v-model="rangeDateReport"
          format="dd/MM/yyyy"
          type="daterange"
          range-separator="A"
          start-placeholder="Fecha de inicio"
          end-placeholder="Fecha de fin"
        >
        </el-date-picker>
        <el-button
          class="my-5 m justify-center"
          type="primary"
          @click="reportingRangePDF()"
          :loading="loading"
          >Ver reporte</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      :visible.sync="showEditTraining"
      width="900px"
      :close-on-click-modal="false"
      top="5%"
      :fullscreen="true"
    >
      <h2 class="text-2xl mb-4 font-bold">Editar Capacitación</h2>
      <el-form
        class="px-8"
        ref="form"
        :model="editingTraining"
        label-position="top"
        label-width="120px"
      >
        <div class="flex  flex-wrap">
          <div class="w-full mr-5">
            <el-form-item label="Titulo">
              <el-input v-model="editingTraining.title"></el-input>
            </el-form-item>
          </div>
          <div class="w-full mr-5">
            <el-form-item label="Clasificación">
              <el-input v-model="editingTraining.clasification"></el-input>
            </el-form-item>
          </div>
          <div class="w-full mr-5">
            <el-form-item label="Capacitador">
              <el-input v-model="editingTraining.trainer"></el-input>
            </el-form-item>
          </div>
          <div class="w-full flex justify-between ">
            <div class="w-64 mr-5">
              <el-date-picker
                v-model="rangeDate"
                format="dd/MM/yyyy"
                type="daterange"
                range-separator="A"
                start-placeholder="Fecha de inicio"
                end-placeholder="Fecha de fin"
              >
              </el-date-picker>
            </div>
            <div class="w-64 mr-5">
              <el-form-item label="Duración">
                <el-input v-model="editingTraining.duration"></el-input>
              </el-form-item>
            </div>
          </div>

          <div class="w-64 mr-5">
            <el-form-item label="Costo Lactolac">
              <el-input v-model="editingTraining.costLac"></el-input>
            </el-form-item>
          </div>
          <div class="w-64 mr-5">
            <el-form-item label="Costo Insaforp">
              <el-input v-model="editingTraining.costInsaforp"></el-input>
            </el-form-item>
          </div>
          <div class="w-64 mr-5">
            <el-form-item label="Costo Total">
              <el-input :value="EditTotalCostComputed"></el-input>
            </el-form-item>
          </div>
          <div class="w-full mr-5">
            <el-form-item label="Comentarios">
              <el-input
                type="textarea"
                :rows="2"
                v-model="editingTraining.comments"
              ></el-input>
            </el-form-item>
          </div>
        </div>
        <el-button type="primary" @click="modifyTraining()" :loading="loading"
          >Editar Capacitación</el-button
        >
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
import * as R from "ramda";
import gql from "graphql-tag";
import { format } from "date-fns";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;
import { getHeader, getFooter, formatMoney } from "../../../utils";

export default {
  name: "TrainingTools",
  data() {
    return {
      actualEmployeeSelected: "",
      rangeDate: "",
      rangeDateReport: "",
      loading: false,
      searchTraining: "",
      trainingsUnfilter: [],
      employees: [],
      editingTraining: {
        id: "",
        title: "",
        clasification: "",
        trainer: "",
        startDate: "",
        endDate: "",
        costLac: 0,
        costInsaforp: 0,
        totalCost: 0,
        duration: 0,
        comments: "",
      },
      errors: [],
      newTraining: {
        title: "",
        clasification: "",
        trainer: "",
        startDate: "",
        endDate: "",
        costLac: 0,
        costInsaforp: 0,
        totalCost: 0,
        duration: 0,
        comments: "",
      },
      showAddTraining: false,
      showEditTraining: false,
      showRangeReport: false,
    };
  },
  beforeRouteEnter(to, from, next) {
    //obtiene los training
    axios
      .post("/", {
        query: `{
          trainings{
            id
            title
            clasification
            trainer
            startDate
            endDate
            costLac
            costInsaforp
            totalCost
            duration
            comments
            employees{
                id
                name1
                name2
                name3
                lastname1
                lastname2
                lastname3
                code
                contractStartDate
                department{name}
            }
          }
          employees(where: { show: true } whereNot: { status: 1 }){
                id
                name1
                name2
                name3
                lastname1
                lastname2
                lastname3
                code
                contractStartDate
                department{ name }
          }
        }`,
      })
      .then((res) => {
        const { data, errors } = res.data;
        if (R.isNil(errors)) {
          next((vm) =>
            vm.setData({
              trainings: data.trainings,
              employees: data.employees,
              trainingsUnfilter: data.trainings,
            })
          );
        } else {
          next(new Error(errors[0].message));
        }
      });
  },
  computed: {
    trainings() {
      if (this.searchTraining == "") {
        return this.trainingsUnfilter;
      } else {
        let info = this.trainingsUnfilter.filter((tr) => {
          return (
            tr.clasification
              .toLowerCase()
              .includes(this.searchTraining.toLowerCase()) ||
            tr.comments
              .toLowerCase()
              .includes(this.searchTraining.toLowerCase()) ||
            tr.title
              .toLowerCase()
              .includes(this.searchTraining.toLowerCase()) ||
            format(tr.startDate, "DD/MM/YYYY").includes(this.searchTraining) ||
            tr.trainer.toLowerCase().includes(this.searchTraining.toLowerCase())
          );
        });

        return info;
      }
    },
    totalCostComputed() {
      this.newTraining.totalCost =
        Number.parseFloat(this.newTraining.costLac) +
        Number.parseFloat(this.newTraining.costInsaforp);
      return this.newTraining.totalCost;
    },
    EditTotalCostComputed() {
      this.editingTraining.totalCost =
        Number.parseFloat(this.editingTraining.costLac) +
        Number.parseFloat(this.editingTraining.costInsaforp);
      return this.editingTraining.totalCost;
    },
  },
  methods: {
    printTraining(d) {
      console.log(d);
      let employeeTable = { text: "No se encontraron empleados asignados" };
      if (d.employees.length > 0) {
        let detailsEmp = [];
        detailsEmp.push([
          { fontSize: 10, text: "Código", bold: true },
          { fontSize: 10, text: "Nombre", bold: true },
          { fontSize: 10, text: "Area", bold: true },
        ]);
        d.employees.forEach((e) =>
          detailsEmp.push([
            { text: e.code, fontSize: 8 },
            {
              text:
                e.name1 +
                " " +
                e.name2 +
                " " +
                e.name3 +
                " " +
                e.lastname1 +
                " " +
                e.lastname2 +
                " " +
                e.lastname3,
              fontSize: 8,
            },
            { fontSize: 8, text: e.department.name },
          ])
        );
        employeeTable = {
          table: {
            widths: [40, "*", "*"],
            margin: [50, 0, 0, 0],
            body: detailsEmp,
          },
        };
      }

      let dd = {
        pageSize: "LETTER",
        pageOrientation: "portrait",
        pageMargins: [20, 60, 20, 40],
        header: getHeader(
          "CALDER, SOCIEDAD ANÓNIMA",
          [new Date()],
          "REPORTE DE CAPACITACIONES",
          "date"
        ),
        footer: getFooter(),
        content: [
          {
            text: "Capacitación: " + d.title,
            alignment: "center",
            fontSize: 12,
            margin: [0, 10, 0, 0],
          },
          {
            text:
              "Del " +
              format(d.startDate, "DD/MM/YYYY") +
              " al " +
              format(d.endDate, "DD/MM/YYYY"),
            alignment: "center",
            fontSize: 12,
            margin: [0, 0, 0, 0],
          },
          {
            text: "Capacitador: " + d.trainer,
            alignment: "center",
            fontSize: 10,
            margin: [0, 0, 0, 2],
          },
          {
            text:
              " \t Costo LACTOLAC: $" +
              d.costLac +
              " \t Costo INSAFORP: $" +
              d.costInsaforp +
              " \t Costo Total: $" +
              d.totalCost,
            alignment: "center",
            fontSize: 10,
          },
          {
            text: "Empleados que asistieron: ",
            bold: true,
            margin: [0, 20, 0, 20],
            fontSize: 10,
          },
          employeeTable,
          {
            text: "Comentarios: " + d.comments,
            margin: [0, 20, 0, 0],
            fontSize: 10,
          },
        ],
      };
      pdfMake.createPdf(dd).open();
    },
    dateFormatJS(ndate) {
      let r = ndate.split("-");
      return new Date(r[1] + "/" + r[2] + "/" + r[0]);
    },
    editTraining(d) {
      this.showEditTraining = true;
      this.rangeDate = [];
      this.rangeDate[0] = this.dateFormatJS(d.startDate);
      this.rangeDate[1] = this.dateFormatJS(d.endDate);
      //console.log(this.dateFormatJS(d.startDate));
      this.editingTraining = { ...d };
      delete this.editingTraining.employees;
      //console.log(d);
    },
    modifyTraining() {
      //console.log(this.editingTraining)

      if (this.editingTraining.title == "") {
        this.$message.warning("El titulo no puede quedar en blanco");
        return;
      }
      if (this.editingTraining.clasification == "") {
        this.$message.warning("La clasificación no puede quedar en blanco");
        return;
      }
      if (this.editingTraining.trainer == "") {
        this.$message.warning("El Capacitador no puede quedar en blanco");
        return;
      }
      if (!this.rangeDate) {
        this.$message.warning("La fecha no puede quedar en blanco");
        return;
      }
      if (this.rangeDate[0] == "") {
        this.$message.warning("La fecha no puede quedar en blanco");
        return;
      }
      if (this.rangeDate[1] == "") {
        this.$message.warning("La fecha no puede quedar en blanco");
        return;
      }
      if (this.editingTraining.costLac < 0) {
        this.$message.warning("Ingrese un costo numerico para LACTOLAC");
        return;
      }
      if (this.editingTraining.costInsaforp < 0) {
        this.$message.warning("Ingrese un costo numerico para INSAFORP");
        return;
      }
      if (this.editingTraining.totalCost < 0) {
        this.$message.warning("Ingrese un costo numerico para LACTOLAC");
        return;
      }
      if (this.editingTraining.duration < 0) {
        this.$message.warning("La duracion no puede durar 0");
        return;
      }

      //mutacion de modificacion de training
      this.loading = true;
      axios
        .post("/", {
          query: `mutation {
  trainingEdit(
    data:{

    title: "${this.editingTraining.title}",
    clasification: "${this.editingTraining.clasification}",
    trainer: "${this.editingTraining.trainer}",
    startDate: "${format(this.rangeDate[0], "DD/MM/YYYY")}"
        endDate: "${format(this.rangeDate[1], "DD/MM/YYYY")}"
    costLac: ${this.editingTraining.costLac},
    costInsaforp: ${this.editingTraining.costInsaforp},
    totalCost: ${this.editingTraining.totalCost},
    duration: ${this.editingTraining.duration},
    comments: "${this.editingTraining.comments}"
    },
    where:{
      id: ${this.editingTraining.id}
    }


  ){
    id
    title
  }

}`,
        })
        .then((res) => {
          const { data, errors } = res.data;
          if (R.isNil(errors)) {
            // v.employees = data.addEmployeesToTraining.employees;
            //v.inp = "";
            let t = this.trainingsUnfilter.find(
              (r) => r.id == this.editingTraining.id
            );
            t.title = this.editingTraining.title;
            t.clasification = this.editingTraining.clasification;
            t.trainer = this.editingTraining.trainer;
            t.startDate = format(this.rangeDate[0], "YYYY-MM-DD");
            t.endDate = format(this.rangeDate[1], "YYYY-MM-DD");
            t.costLac = this.editingTraining.costLac;
            t.costInsaforp = this.editingTraining.costInsaforp;
            t.totalCost = this.editingTraining.totalCost;
            t.duration = this.editingTraining.duration;
            t.comments = this.editingTraining.comments;

            this.loading = false;
            this.showEditTraining = false;
          } else {
            this.loading = false;
            new Error(errors[0].message);
          }
        })
        .catch((err) => {
          this.loading = false;
          console.log(err);
          this.$message.error(err.message);
        });
    },
    async reportingRangePDF() {
      //generando reporte PDF por rangos de fecha
      if (!this.rangeDateReport) {
        this.$message.warning("La fecha no puede quedar en blanco");
        return;
      }
      if (this.rangeDateReport[0] == "") {
        this.$message.warning("La fecha no puede quedar en blanco");
        return;
      }
      if (this.rangeDateReport[1] == "") {
        this.$message.warning("La fecha no puede quedar en blanco");
        return;
      }

      this.loading = true;

      axios
        .post("/", {
          query: `mutation{
                    trainingReport(
                      where:{
                        start:"${format(this.rangeDateReport[0])}"
                        end:"${format(this.rangeDateReport[1])}"
                      }
                    ){
                    id
                      title
                      clasification
                      trainer
                      startDate
                      endDate
                      costLac
                      costInsaforp
                      totalCost
                      duration
                      comments
                      employees{
                        id
                        code
                        name1
                        name2
                        name3
                        lastname1
                        lastname2
                        lastname3
                        department{
                          name
                        }
                      }

                    }
                  }`,
        })
        .then((res) => {
          const { data, errors } = res.data;
          if (R.isNil(errors)) {
            let info = data.trainingReport;
            this.loading = false;
            //EJECUTANDO LA CREACION DEL PDF
            let reporte = [];

            if (info.length == 0) {
              reporte.push({
                text:
                  "No se encontraron capacitaciones en el rango seleccionado ",
                fontSize: 12,
                margin: [40, 10, 0, 0],
              });
            } else {
              info.forEach((d) => {
                //agregando listado de empleados*******************
                let employeeTable = {
                  text: "---- No se encontraron empleados asignados ----",
                };
                if (d.employees.length > 0) {
                  let detailsEmp = [];
                  detailsEmp.push([
                    { fontSize: 10, text: "Código", bold: true },
                    { fontSize: 10, text: "Nombre", bold: true },
                    { fontSize: 10, text: "Area", bold: true },
                  ]);
                  d.employees.forEach((e) =>
                    detailsEmp.push([
                      { text: e.code, fontSize: 8 },
                      {
                        text:
                          e.name1 +
                          " " +
                          e.name2 +
                          " " +
                          e.name3 +
                          " " +
                          e.lastname1 +
                          " " +
                          e.lastname2 +
                          " " +
                          e.lastname3,
                        fontSize: 8,
                      },
                      { fontSize: 8, text: e.department.name },
                    ])
                  );
                  employeeTable = {
                    table: {
                      widths: [40, "*", "*"],
                      margin: [20, 0, 0, 0],
                      body: detailsEmp,
                    },
                  };
                }

                //agregando datos generales de las capacitaciones.
                reporte.push(
                  {
                    text: "Capacitación: " + d.title,
                    alignment: "center",
                    fontSize: 12,
                    margin: [0, 10, 0, 0],
                  },
                  {
                    text:
                      "Del " +
                      format(d.startDate, "DD/MM/YYYY") +
                      " al " +
                      format(d.endDate, "DD/MM/YYYY"),
                    alignment: "center",
                    fontSize: 12,
                    margin: [0, 0, 0, 0],
                  },
                  {
                    text: "Capacitador: " + d.trainer,
                    alignment: "center",
                    fontSize: 10,
                    margin: [0, 0, 0, 2],
                  },
                  {
                    text:
                      " \t Costo LACTOLAC: $" +
                      d.costLac +
                      " \t Costo INSAFORP: $" +
                      d.costInsaforp +
                      " \t Costo Total: $" +
                      d.totalCost,
                    alignment: "center",
                    fontSize: 10,
                  },
                  {
                    text: "Empleados que asistieron: ",
                    bold: true,
                    margin: [0, 20, 0, 20],
                    fontSize: 10,
                  },

                  employeeTable,
                  { text: "Comentarios: " + d.comments, margin: [0, 10, 0, 0] },
                  {
                    text:
                      "----------------------------------------------------------------------------------------------------------------------------------",
                  },
                  {
                    text:
                      "----------------------------------------------------------------------------------------------------------------------------------",
                  }
                );
              });
            }

            let dd = {
              pageSize: "LETTER",
              pageOrientation: "portrait",
              pageMargins: [20, 60, 20, 40],
              header: getHeader(
                "CALDER, SOCIEDAD ANÓNIMA",
                [this.rangeDateReport[0], this.rangeDateReport[1]],
                "REPORTE DE CAPACITACIONES - ",
                "period"
              ),
              footer: getFooter(),
              content: reporte,
            };
            pdfMake.createPdf(dd).open();
          } else {
            this.loading = false;
            new Error(errors[0].message);
          }
        })
        .catch((err) => {
          this.loading = false;
          console.log(err);
          this.$message.error(err.message);
        });
    },
    employeesFiltered(addedEmployees) {
      return this.employees.filter(
        (emp) => !addedEmployees.map((a) => a.code).includes(emp.code)
      );

      // if(addedEmployees.length>0){

      //   return this.employees.filter((emp)=>{
      //     let codes = addedEmployees.map((aemp)=>{return aemp.code})
      //     return !codes.includes(emp.code)
      //   });
      // }else{
      //   return this.employees;
      // }
    },
    addEmployeeToTraning(v) {
      if (this.actualEmployeeSelected == "") {
        this.$message.warning("Seleccione un empleado a agregar");
        return;
      }

      this.loading = true;
      axios
        .post("/", {
          query: `mutation{
            addEmployeesToTraining(
              data:{
                employeeId:${this.actualEmployeeSelected}
                trainingId: ${v.id}
              }
            ){
             employees{
                id
                name1
                name2
                name3
                lastname1
                lastname2
                lastname3
                code
                contractStartDate
                department{name}
              }
            }
        }`,
        })
        .then((res) => {
          const { data, errors } = res.data;
          if (R.isNil(errors)) {
            v.employees = data.addEmployeesToTraining.employees;
            v.inp = "";
            this.actualEmployeeSelected = "";
            this.loading = false;
          } else {
            this.loading = false;
            new Error(errors[0].message);
          }
        })
        .catch((err) => {
          this.loading = false;
          console.log(err);
          this.$message.error(err.message);
        });
    },
    deleteEmployeeToTraning(v, em) {
      this.$confirm(`¿Remover de la capacitación?`, "Confirmación", {
        confirmButtonText: "Si",
        cancelButtonText: "No",
        type: "warning",
      })
        .then(() => {
          this.loading = true;
          axios
            .post("/", {
              query: `mutation{
  deleteEmployeesToTraining(
    data:{
      employeeId:${em}
      trainingId: ${v.id}
    }
  ){
      employees{
                id
                name1
                name2
                name3
                lastname1
                lastname2
                lastname3
                code
                contractStartDate
                department{name}
              }
            }
}`,
            })
            .then((res) => {
              const { data, errors } = res.data;
              if (R.isNil(errors)) {
                v.employees = data.deleteEmployeesToTraining.employees;
                v.inp = "";
                this.loading = false;
              } else {
                this.loading = false;
                new Error(errors[0].message);
              }
            })
            .catch((err) => {
              this.loading = false;
              console.log(err);
              this.$message.error(err.message);
            });
        })
        .catch(() => {});
    },
    resetNewTraining() {
      this.newTraining = {
        title: "",
        clasification: "",
        trainer: "",
        startDate: "",
        endDate: "",
        costLac: 0,
        costInsaforp: 0,
        totalCost: 0,
        duration: 0,
        comments: "",
      };
    },
    createTraining() {
      if (this.newTraining.title == "") {
        this.$message.warning("El titulo no puede quedar en blanco");
        return;
      }
      if (this.newTraining.clasification == "") {
        this.$message.warning("La clasificación no puede quedar en blanco");
        return;
      }
      if (this.newTraining.trainer == "") {
        this.$message.warning("El Capacitador no puede quedar en blanco");
        return;
      }
      if (!this.rangeDate) {
        this.$message.warning("La fecha no puede quedar en blanco");
        return;
      }
      if (this.rangeDate[0] == "") {
        this.$message.warning("La fecha no puede quedar en blanco");
        return;
      }
      if (this.rangeDate[1] == "") {
        this.$message.warning("La fecha no puede quedar en blanco");
        return;
      }
      if (this.newTraining.costLac < 0) {
        console.log(this.newTraining.costLac);
        this.$message.warning("Ingrese un costo numerico para LACTOLAC");
        return;
      }
      if (this.newTraining.costInsaforp < 0) {
        this.$message.warning("Ingrese un costo numerico para INSAFORP");
        return;
      }
      if (this.newTraining.totalCost < 0) {
        this.$message.warning("Ingrese un costo numerico para LACTOLAC");
        return;
      }
      if (this.newTraining.duration < 0) {
        this.$message.warning("La duracion no puede durar 0");
        return;
      }
      this.loading = true;

      axios
        .post("/", {
          query: `mutation {
  trainingCreate(
    data:{
        title:"${this.newTraining.title}"
        clasification: "${this.newTraining.clasification}"
        trainer: "${this.newTraining.trainer}"
        startDate: "${format(this.rangeDate[0], "DD/MM/YYYY")}"
        endDate: "${format(this.rangeDate[1], "DD/MM/YYYY")}"
        costLac: ${this.newTraining.costLac}
        costInsaforp: ${this.newTraining.costInsaforp}
        totalCost: ${this.newTraining.totalCost}
        duration: ${this.newTraining.duration}
        comments: "${this.newTraining.comments}"
    }
  ){
    id
    title
    clasification
    trainer
    startDate
    endDate
    costLac
    costInsaforp
    totalCost
    duration
    comments
    employees{
        id
        name1
        name2
        name3
        lastname1
        lastname2
        lastname3
        code
        contractStartDate
    department{
      name
    }
  }
  }
}`,
        })
        .then((res) => {
          const { data, errors } = res.data;
          if (R.isNil(errors)) {
            this.setData({ trainings: data.trainingCreate });
            this.loading = false;
            this.showAddTraining = false;
            this.resetNewTraining();
          } else {
            this.loading = false;
            new Error(errors[0].message);
          }
        })
        .catch((err) => {
          this.loading = false;
          console.log(err);
          this.$message.error(err.message);
        });
    },
    showModalNewTraining() {
      this.resetNewTraining();
      this.showAddTraining = true;
    },
    showModalRangeReport() {
      this.showRangeReport = true;
    },
    setData({ trainings, employees, trainingsUnfilter }) {
      this.trainingsUnfilter = trainings.map((t) => {
        return {
          ...t,
          inp: "",
        };
      });
      if (employees) {
        this.employees = employees;
      }
      if (trainingsUnfilter) {
        this.trainingsUnfilter = trainingsUnfilter;
      }
      //console.log(trainings);
    },
    fullname({
      code,
      name1,
      name2,
      name3,
      lastname1,
      lastname2,
      lastname3,
      department,
    }) {
      let name = [name1, name2, name3, lastname1, lastname2, lastname3]
        .filter((e) => e)
        .map((e) => e.trim())
        .join(" ");
      return (code ? code : " NC ") + " - " + name;
    },
  },
};
</script>
